import React from 'react'

import Drawer from '@material-ui/core/Drawer';
import { makeStyles } from "@material-ui/core/styles";

import Icon from "../Icon";

import './index.scss';


export default ({ className, open, children, closeFn, ...rest }) => {
    let isOpen = open;
    const useStyles = makeStyles({
        paper: rest.paperStyles
    });
    const styles = useStyles();
    delete rest.paperStyles;
    return(
    <Drawer 
        open={isOpen} 
        className={"generalDrawer " + className} 
        {...rest}
        classes={{ paper: styles.paper }}
    >
        {closeFn && <Icon onClick={() => closeFn()} icon="feather-x"/>}
        {children}
    </Drawer>
    );
}